export default __webpack_public_path__ + "static/media/age.cde40510.svg";